import React from "react";
import { tableStyle } from "../ticketModule/variables/ListingVariables";
import { Table } from "../../components/CustomPaginations";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";

const TimeSheetStatusTable = (props) => {
	return (
		<>
			<PaginationProvider
				pagination={paginationFactory({
					custom: true,
					totalSize: props.pagerData ? props.pagerData.TotalCount : 0,
					page: props.pageNum,
					sizePerPage: props.numberOfItemsPerPage,
					paginationSize: props.numberOfItemsPerPage,
				})}
			>
				{({ paginationProps, paginationTableProps }) => {
					return (
						<Table
							keyField="id"
							columns={props.columns}
							items={props.tableData}
							tableLoader={props.tableLoader}
							tableStyle={tableStyle}
							paginationProps={paginationProps}
							paginationTableProps={paginationTableProps}
							defaultSorted={props.defaultSorted}
							pagerData={props.pagerData}
							onTablePageChange={props.handleTableChange}
							SearchBar={() => {
								return null;
							}}
							receiveData={(PageSize) => {
								props.receiveData(PageSize);
							}}
							rowEvents={props.rowEvents}
						/>
					);
				}}
			</PaginationProvider>
		</>
	);
};

export default TimeSheetStatusTable;
